import {ChartOptions} from "../../../../actions/queryBuilderApi";
import {ReactECharts} from "../../../../components/charts/ReactECharts";
import {useChartDataFetcher} from "./chartDataFetcher";
import React, {useEffect} from "react";
import {lineChartOption} from "./lineChartOption";
import {bubbleSortLine} from "./ChartUtil";

export type LineChartProps = {
    chartOptions: ChartOptions
    setSortDisabled(disabled: boolean): void
}

export const LineChart = ({chartOptions, setSortDisabled}: LineChartProps) => {
    const chartData = useChartDataFetcher(chartOptions)
    if (chartData.values.length > 0) {
        bubbleSortLine(chartData, chartOptions.sort)
    }

    useEffect(() => {
        if (chartData.values.length > 1) {
            setSortDisabled(true)
        } else {
            setSortDisabled(false)
        }
    }, [chartData.values.length]) // eslint-disable-line react-hooks/exhaustive-deps

    if (chartOptions.sort !== 0 && chartOptions.topTen) {
        chartData
            .values
            .map(i => i.data.splice(10, i.data.length - 10))
        chartData.labels.splice(10, chartData.labels.length - 10)
    }

    const lineChartOptions = lineChartOption(chartData)
    return <ReactECharts option={lineChartOptions} settings={{notMerge: true}}/>
}